<!-- 通过访问接口登录，登录成功后跳转到home页面  -->
<template>
  <div id="platfrom_login_jump"></div>
</template>
<script>
import {
  http_userLoginfo,
  https_manage_getGroupData,
} from '@api/platfrom_base_api'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
export default {
  name: 'platfrom_login_jump',
  mixins: [customizeProMixins_data_mixin],
  data() {
    return {
      // 账号|邮箱
      email: '',
      // 密码
      password: '',
      showPassword: true,
      // 错误提示文案
      errors: '',
      // 密码格式是否通过验证
      passwordSuccess: false,
      // 邮箱是否通过验证
      emailSuccess: false,
      // 防止连续点击
      loading: false,
      // isLogin: false, //登录后关闭动画
      // currSeasonMap: {
      //   asianGames: {
      //     //换赛季替换的内容
      //     cid: 'ASG',
      //     sid: 'ASG19',
      //     name: '2022杭州亚运会',
      //     sportType: 'compreSportsMeet',
      //   },
      // },
      routerPath: 'platfromHomeIndex',
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    async init() {
      await this.getGroupData()
      await this.getUserInfor()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    //确认登录
    async getUserInfor() {
      this.loading = true
      http_userLoginfo('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug(res)

          if (res.status == 0) {
            const query = this.$route.query
            // 存储信息到localstorage
            // let identy = res.data.identy; //判断能进入哪个权限页面
            this.$localStorage.setItem(
              'mixtmt_userInfo',
              JSON.stringify(res.data)
            )

            if (query.website && query.redirect_url) {
              // 跳转到其他站点
              console.debug('跳转到其他站点')
              window.location = query.redirect_url
            } else {
              console.debug(this.routerPath)
              this.$router.replace({
                name: this.routerPath,
              })
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      this.loading = false
    },
    async getGroupData() {
      await https_manage_getGroupData('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug('正常')
          if (res.status === 0) {
            this.$localStorage.setItem(
              'mixtmt_groupList',
              JSON.stringify(res.data)
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
